import { browserName, isAndroid } from 'react-device-detect';

export const redirectToDefaultBrowser = (browser = 'Facebook') => {
	if (window) {
		if (browserName === browser && isAndroid) {
			window.location = `intent:${window.location}#Intent;end`;
		}
	}
};
